import { queryKeys } from '@/lib/query-keys';
import { apiError } from '@/lib/api/ts-rest';
import { orgMembersClient } from '@/lib/api/ts-rest';
import { useQuery } from '@tanstack/react-query';

export function usePendingInvitations({
  organizationId,
}: {
  organizationId: string | undefined;
}) {
  return useQuery({
    queryKey: queryKeys.organizations.pendingInvitations(organizationId),
    queryFn: async () => {
      const res = await orgMembersClient.listPendingInvitations({
        params: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw apiError(res, 'Failed to load invitations');
      return res.body;
    },
    enabled: !!organizationId,
    retry: false,
  });
}
